import {
    Box,
    Button,
    ButtonGroup,
    List,
    ListItem,
    Stack,
    Typography,
} from "@mui/material";
import React from "react";
import styles from "../../../styles/components/video.module.scss";
import styles1 from "../../../styles/components/submitterDetails.module.scss";
import {
    concatHostAndImagePath,
    emptyHandle,
} from "../../../lib/functions/utils.lib";
import assest from "../../../json/assest";
import MediaFileIcon from "../../../ui/Icons/MediaFileIcon";
import DownloadStyledIcon from "../../../ui/Icons/DownloadStyledIcon";
import ViewIcon from "../../../ui/Icons/ViewIcon";

const MessageSubmitterDetails = ({ data, hideCross, onClose }) => {
    return (
        <>
            {data && (
                <Box
                    className={`VideocommonBox VideocommonBoxsubmit ${
                        data.unreachable_submitter ? "VideocommonBoxError" : ""
                    } ${styles1.submitDetailsModal}`}
                >
                    <Box
                        className={`${styles.ownerDetails} ${
                            data.unreachable_submitter
                                ? styles.ownerDetailsError
                                : ""
                        }`}
                    >
                        <Box
                            className={`${styles.commonHeading} ${styles1.submittercommonHeading}`}
                        >
                            <h4>
                                <label>Submitter Details</label>
                            </h4>
                        </Box>

                        <Box
                            className={`${styles.ownerDetailsTxt} ${styles1.ownerDetailsTxtSubmitted}`}
                        >
                            <List>
                                <ListItem
                                    className={styles1.submittedFirstField}
                                >
                                    <Box className={styles.ownerDetailsTxtBox}>
                                        <h4>Full Name</h4>
                                        <h5>
                                            {data?.user?.name}
                                            {data?.user?.last_name}
                                        </h5>
                                    </Box>
                                </ListItem>
                                <ListItem
                                    className={styles1.submittedSecondField}
                                >
                                    <Box
                                        className={`${styles.ownerDetailsTxtBox} ${styles.ownerDetailsTxtBoxError}`}
                                    >
                                        <h4>
                                            Email Address{" "}
                                            {data?.unreachable_submitter ? (
                                                <span>(Unreachable Email)</span>
                                            ) : (
                                                <></>
                                            )}
                                        </h4>
                                        <h5>{data?.user?.email}</h5>
                                    </Box>
                                </ListItem>
                                <ListItem
                                    className={styles1.submittedThirdField}
                                >
                                    <Box className={styles.ownerDetailsTxtBox}>
                                        <h4>Date of Birth</h4>
                                        <h5>
                                            {data?.birthdate
                                                ? data?.birthdate
                                                : "N/A"}
                                        </h5>
                                    </Box>
                                </ListItem>
                                <ListItem
                                    className={styles1.submittedFirstField}
                                >
                                    <Box className={styles.ownerDetailsTxtBox}>
                                        <h4>Phone Number</h4>
                                        <h5>
                                            {data?.phone ? data?.phone : "N/A"}
                                        </h5>
                                    </Box>
                                </ListItem>
                                <ListItem
                                    className={styles1.submittedSecondField}
                                >
                                    <Box className={styles.ownerDetailsTxtBox}>
                                        <h4>Social Media Handles</h4>
                                        <h5>
                                            {emptyHandle(data.video_credit)}
                                        </h5>
                                    </Box>
                                </ListItem>
                                <ListItem
                                    className={styles1.submittedThirdField}
                                >
                                    {/* <Box className={styles.ownerDetailsTxtBox}>
                    <h4>Signature </h4>
                    {data?.signature ? (
                      <img
                        src={concatHostAndImagePath(data?.signature)}
                        width={38}
                        height={34}
                        alt=""
                      />
                    ) : (
                      "N/A"
                    )}
                  </Box> */}

                                    <Stack
                                        direction={"row"}
                                        alignItems={"flex-start"}
                                        flexWrap={"wrap"}
                                        className={styles.ownerMedia}
                                    >
                                        <Box className={styles.mediaLeft}>
                                            <MediaFileIcon />
                                        </Box>
                                        <Box className={styles.mediaRight}>
                                            <Typography variant="h5">
                                                {data?.user?.name
                                                    ? data?.user?.name
                                                    : ""}{" "}
                                                {data?.user?.last_name
                                                    ? data?.user?.last_name
                                                    : ""}
                                            </Typography>
                                            <Stack
                                                direction={"row"}
                                                alignItems={"center"}
                                                justifyContent={"space-between"}
                                            >
                                                <Typography variant="caption">
                                                    PDF
                                                </Typography>
                                                <ButtonGroup>
                                                    <Button>
                                                        <DownloadStyledIcon />
                                                    </Button>
                                                    <Button
                                                        className={
                                                            styles.viewFiles
                                                        }
                                                    >
                                                        <ViewIcon />
                                                    </Button>
                                                </ButtonGroup>
                                            </Stack>
                                        </Box>
                                    </Stack>
                                </ListItem>
                            </List>
                        </Box>
                    </Box>
                    {!hideCross && (
                        <Button
                            onClick={onClose}
                            className={styles1.submitDetailsModalcross}
                        >
                            <img
                                src={assest.crossBlack}
                                width={21}
                                height={21}
                                alt=""
                            />
                        </Button>
                    )}
                </Box>
            )}
        </>
    );
};

export default MessageSubmitterDetails;
